/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Scope_Point_1Inputs */

const en_svc_rag_scope_point_1 = /** @type {(inputs: Svc_Rag_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal AI assistant for policies, procedures and product detail`)
};

const lv_svc_rag_scope_point_1 = /** @type {(inputs: Svc_Rag_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iekšējais AI asistents noteikumiem, procedūrām un produktu detaļām`)
};

/**
* | output |
* | --- |
* | "Internal AI assistant for policies, procedures and product detail" |
*
* @param {Svc_Rag_Scope_Point_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_scope_point_1 = /** @type {((inputs?: Svc_Rag_Scope_Point_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Scope_Point_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_scope_point_1(inputs)
	return en_svc_rag_scope_point_1(inputs)
});